import React, { useRef } from "react";
import { Button, Form, ListGroup } from "react-bootstrap";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || "").split(",").pop() || "");
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export default function EvidenceUploader({ files = [], onChange, disabled = false }) {
  const inputRef = useRef(null);

  const onSelectFiles = async (event) => {
    const selected = Array.from(event.target.files || []);
    if (!selected.length) return;

    const mapped = [];
    for (const file of selected) {
      // Convertimos antes de persistir para usar el endpoint actual sin multipart.
      const contenidoBase64 = await toBase64(file);
      mapped.push({
        nombreArchivo: file.name,
        mimeType: file.type || "application/octet-stream",
        contenidoBase64,
        tipo: file.type?.startsWith("audio/") ? "AUDIO" : file.type?.startsWith("image/") ? "IMAGEN" : "ARCHIVO",
        tamanoBytes: file.size,
      });
    }

    onChange?.([...(files || []), ...mapped]);
    event.target.value = "";
  };

  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex gap-2 align-items-center">
        <Button variant="outline-secondary" size="sm" disabled={disabled} onClick={() => inputRef.current?.click()}>
          Adjuntar archivos
        </Button>
        <span className="text-muted small">png, jpg, jpeg, pdf, mp3, wav, m4a</span>
      </div>
      <Form.Control ref={inputRef} type="file" multiple hidden onChange={onSelectFiles} />
      {!files?.length ? (
        <div className="text-muted small">Todavía no hay archivos cargados.</div>
      ) : (
        <ListGroup>
          {files.map((file, index) => (
            <ListGroup.Item key={`${file.nombreArchivo}-${index}`} className="d-flex justify-content-between align-items-center">
              <div>
                <div className="fw-semibold">{file.nombreArchivo}</div>
                <div className="small text-muted">{file.mimeType || file.tipo || "Archivo"}</div>
              </div>
              <Button
                variant="outline-danger"
                size="sm"
                disabled={disabled}
                onClick={() => onChange?.(files.filter((_, itemIndex) => itemIndex !== index))}
              >
                Quitar
              </Button>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </div>
  );
}
